import Chart from '@/chart'
import { halfGridLines } from '@/assets/charts/plugins/gridLines.js'
import { pdfFontSize } from '../../assets/js/settings'
import pallete from '@/assets/js/pallete'

export function parseData(data){

    const baseline_val = data[0] ? data[0].indexOf(1) : -1
    const parsed_data = data[1] ? data[1].map(val => 100*val) : null
   
    return {
        baseline_val: baseline_val === -1 ? null : baseline_val,
        parsed_data
    }
}

function getData(data, labels){

    const { baseline_val, parsed_data } = parseData(data)
    
    return {
        labels,
        baseline: (baseline_val !== null) ? labels[baseline_val] : null,
        datasets: [{
            label: 'First Dataset',
            data: parsed_data
        }]
    }
}

function getOptions(params, pdf=false){
    
    let colors = pallete

    if (params.pallete){
        colors = [...params.pallete, ...pallete]
    }
    
    let options = {
        scales: {
            y: {
                min: 0,
                max: 100,
                ticks: {
                    callback: function(value){
                        return `${value}%`
                    }
                }
            },
            x: {
                grid: {
                    display: false
                }
            }
        },
        aspectRatio: 1.5,
        backgroundColor: colors,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        }
    }

    if (pdf) {
        options.animation = false
        options.responsive = false
        options.scales.y.ticks['font'] = {
            size: pdfFontSize
        }
        options.scales['x'] = {
            ticks: {
                font: {
                    size: pdfFontSize
                }
            }
        }
    }

    return options
}

function getConfig(data, labels, params, pdf=false){

    labels = params.alt_states ? params.alt_states : labels

    return {
        type: 'stateChange',
        data: getData(data, labels, params),
        options: getOptions(params, pdf),
        plugins: [halfGridLines]
    }
}

export function initChart(ctx, labels, data, params={}){
    return new Chart(ctx, getConfig(data, labels, params));
}

export function pdfChart(ctx, labels, data, params={}){
    return new Chart(ctx, getConfig(data, labels, params, true));
}
